import {PrimeIcons} from "primereact/api";
import {useTranslation} from "react-i18next";

import type {ValueOrderData} from "@reva/shared/value-order";

import {DetailsPanel, DetailsPanelRow, DetailsPanelSeparator} from "../../component/panels";

interface PanelBankProps {
    orderData: ValueOrderData;
}

export function PanelBank({orderData}: PanelBankProps) {
    const {t} = useTranslation();

    const orderDetails = orderData.orderDetails;

    // Vor- und Nachname sind beide optional; fehlen beide, bleibt der Name leer und die Zeile entfällt.
    const clerkFullName = [orderDetails.clerk?.firstName, orderDetails.clerk?.surname].filter(Boolean).join(" ");

    return (
        <DetailsPanel icon={"pi pi-building-columns"} title={t("order.bank.title")}>
            <DetailsPanelRow
                label={t("order.bank.client")}
                value={orderDetails.clientInformation?.name}
                renderValue={(clientName) => (
                    <>
                        {clientName}
                        <span className="text-xs ml-2 opacity-70">
                            ({orderDetails.clientInformation?.abbreviation})
                        </span>
                    </>
                )}
            />
            <DetailsPanelRow
                label={t("order.bank.clientDepartment")}
                value={orderDetails.clientInformation?.department}
            />
            <DetailsPanelRow label={t("order.bank.clientOrderReference")} value={orderDetails.clientOrderReference} />
            <DetailsPanelRow label={t("order.bank.clientGuid")} value={orderData.valueClientGuid} />

            <DetailsPanelSeparator />

            <DetailsPanelRow label={t("order.bank.clerk")} value={clerkFullName} />
            <DetailsPanelRow
                icon={PrimeIcons.ENVELOPE}
                label={t("order.bank.clerkEmail")}
                value={orderDetails.clerk?.email}
            />
            <DetailsPanelRow
                icon={PrimeIcons.PHONE}
                label={t("order.bank.clerkPhoneBusiness")}
                value={orderDetails.clerk?.phoneBusiness}
            />
        </DetailsPanel>
    );
}
